export enum Role {
    User = 'ROLE_BASIC_USER',
    SuperAdmin = 'ROLE_SUPER_ADMIN',
    CustomerAdmin = 'ROLE_CUSTOMER_ADMIN',
    Mentor = 'ROLE_MENTOR',
    FilialeMentor = 'ROLE_FILIALE_MENTOR',
    MultipleMentor = 'ROLE_MULTIPLE_MENTOR',
    MasterGuide = 'ROLE_MASTER_GUIDE',
    All = 'ROLE_ALL'
}